const settings = {
  DEBUG: process.env.REACT_APP_DEBUG !== '0' || false,
  SERVERROLE: process.env.REACT_APP_SERVERROLE || 'PROD',
  MODULE: process.env.REACT_APP_MODULE || 'FO',
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
  API_PUBLIC_URL: process.env.REACT_APP_API_PUBLIC_URL,
  SITE_KEY: process.env.REACT_APP_SITE_KEY,
  SITE_KEY_V2: process.env.REACT_APP_SITE_KEY_V2,
  DB_DATETIME_FORMAT: process.env.REACT_APP_DB_DATETIME_FORMAT || 'YYYY-MM-DDTHH:mm:ssZ',
  DB_DATE_FORMAT: process.env.REACT_APP_DB_DATE_FORMAT || 'YYYY-MM-DD',
  API_LENGTH_THRESHOLD: 1048576,
  UPLOAD_FILE_SIZE_LIMIT: 50 * 1024 * 1024,
  LANGUAGE: 'sk',
  HOMEPAGE: process.env.REACT_APP_HOMEPAGE || '/',
  API_CLIENT_TIMEOUT: 1000 * 60 * 3,
  CI_COMMIT_HASH: process.env.REACT_APP_CI_COMMIT_HASH,
  DEBUG_I18N: process.env.REACT_APP_DEBUG_I18N !== '0' || false
};
export default settings;
